<script>
export default {
  props: {
    testUser: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      now: new Date().getTime(),
      timeLimit: null,
    }
  },
  computed: {
    timeLeft() {
      if (this.timeLimit - this.now > 60000) {
        // Return minutes left
        return `${Math.floor((this.timeLimit - this.now) / 60000)} min`;
      } else if (this.timeLimit - this.now > 0) {
        // Retrun seconds left
        return `${Math.floor((this.timeLimit - this.now) / 1000)} sec`;
      } else {
        // Handle false values
        return "Calculating...";
      }
    }
  },
  mounted() {
    this.countdown();
  },
  methods: {
    countdown() {
      // set check interval
      var timeout = 3
      const t = setInterval(() => {
        if (this.testUser.loggedIn) {
          // logged in?
          this.timeLimit =
            Number(this.testUser.data.accessLimit) * 60000 +
            this.testUser.data.accessDate.getTime()
          if (this.now > this.timeLimit - 1000) {
            // time expired
            console.log('Session expired')
            this.$emit('timer-end');
            clearInterval(t)
          } else {
            // session still valid
            this.now = new Date().getTime();
          }
        } else {
          // make sure we stop if user not logged in after a certain timeout
          timeout--
          if (timeout < 0) clearInterval(t)
        }
      }, 1000) // check every second
    }
  },
}
</script>

<template>
  <div class="timer">
    Time left:
    <span class="countdown">{{ timeLeft }}</span>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.timer {
  text-align: right;
  font-size: 1.25rem;
  padding: 0.5rem 1rem;

  .countdown {
    font-weight: bold;
  }
}
</style>
